import { Injectable } from '@angular/core';
import { DomService } from '@nibtravel/shared/util/dom';

import { ActionFieldObject, EcommerceProduct } from '../models';
import {
  AddToCart,
  Checkout,
  Purchase,
  RemoveFromCart,
} from '../models/gtm.helpers';

@Injectable()
export class EcommerceService {
  constructor(private domService: DomService) {}

  addToCart(
    products: EcommerceProduct[],
    actionField?: ActionFieldObject
  ): void {
    this.domService.addToDataLayer(AddToCart({ actionField, products }));
  }

  removeFromCart(
    products: EcommerceProduct[],
    actionField?: ActionFieldObject
  ): void {
    this.domService.addToDataLayer(RemoveFromCart({ actionField, products }));
  }

  checkout(products: EcommerceProduct[], actionField: ActionFieldObject): void {
    this.domService.addToDataLayer(Checkout({ actionField, products }));
  }

  purchase(products: EcommerceProduct[], actionField: ActionFieldObject): void {
    this.domService.addToDataLayer(Purchase({ actionField, products }));
  }
}
